import _ from 'lodash'
import mapObjTypes from '@/consts/mapObjTypes'

export default {
    setUser(state, user) {
        state.user = user
    },
    resetUser(state) {
        state.user = false
    },
    setCams(state, cams) {
        const old = state.cams
        let _cams = cams.map(cam => {
            let icon = []

            icon.push(!! cam.settings.telemetry_id ? 'swivel' : 'default')

            if (cam.status.recorded == '1')
                icon.push('rec')

            if (['DISARM_DETACHED', 'DETACHED'].includes(cam.status.state) || cam.status.valid === false)
                icon.push('detached')
            else if (cam.status.focused === "false" || cam.status.unblinded === "false" || cam.status.state === 'ALARMED')
                icon.push('alarmed')

            const oldCam = old.find(c => c.id === cam.id)

            return {
                ...cam,
                image: oldCam ? oldCam.image : null,
                selected: false,
                icon: icon.join(' '),
            }
        })

        _cams = [
            ..._cams.filter(item => item.id.indexOf('#') === -1),
            ..._.sortBy(_cams.filter(item => item.id.indexOf('#') > -1), item => { return item.name }),
        ]

        state.cams = _cams
    },
    setCamIdFromCell(state, camId) {
        state.camIdFromCell = camId
    },
    setViews(state, views) {
        views = views.map(view => {
            return {
                ...view,
                changed: false,
                temp: false,
                selected: false
            }
        })

        state.views = [
            {
                id: 'main',
                name: 'Main View',
                changed: false,
                temp: true,
                cams: [],
                grid: state.grids[0].value
            },
            ...views
        ]
    },
    saveView(state, view) {
        let existing = state.views.find(v => v.id == view.id)

        if (existing) {
            Object.assign(existing, view)
            existing.changed = false
        } else {
            state.views.push({
                ...view,
                changed: false,
                temp: false
            })
        }
    },
    removeView(state, viewId) {
        state.views = state.views.filter(view => view.id != viewId)
    },
    changeViewGrid(state, { grid, viewId }) {
        let view = state.views.find(view => view.id == viewId) || null

        if (view) {
            view.grid = grid
            view.changed = true
        }
    },
    changeStream(state, stream) {
        state.stream = stream
    },
    addCamsIntoView(state, { camIds, viewId }) {
        let view = state.views.find(view => view.id == viewId)

        if (view) {
            view.changed = true

            view.cams.forEach((cam, i) => {
                if ( ! cam) {
                    view.cams[i] = camIds.shift()
                }
            })

            view.cams = [ ...view.cams, ...camIds]

            if (view.cams.length > state.grids.find(g => g.value == view.grid).max) {
                let grid = state.grids.find(g => g.max >= view.cams.length) || _.last(state.grids)
                view.grid = grid.value
            }

            state.grid = view.grid
        }
    },
    removeCamFromView(state, { camId, viewId }) {
        let view = state.views.find(view => view.id == viewId)

        if (camId === null) {
            view.cams = []
            view.changed = true
            return
        }

        let index = view.cams.findIndex(id => id == camId)

        if (view && index > -1) {
            view.cams[index] = null

            let last = null

            view.cams.forEach((cam, i) => {
                if (cam)
                    last = i + 1
            })

            view.cams = last === null ? [] : view.cams.slice(0, last)
            view.changed = true
        }
    },
    replaceCam(state, { camId, replacedCamId, viewId, }) {
        let view = state.views.find(view => view.id == viewId)
        let index = view.cams.findIndex(id => id == replacedCamId)
        let cams = [ ...view.cams ]

        cams[index] = camId
        view.cams = cams
        view.changed = true
    },
    resetTempView(state) {
        state.views[0].grid = state.grids[0].value
        state.views[0].cams = []
        state.views[0].changed = false
    },
    setMaps(state, maps) {
        maps.forEach(map => {
            let items = []
            _.forEach(map.map, (item, i) => {

                const itemProcessed = {
                    ...item,
                    id: i,
                    imageId: item.image.split('/').pop(),
                    image: null,
                    parent: item.parent || 0,
                    width: null,
                    height: null,
                    group: { 'id': map.id, 'name': map.name }
                }

                itemProcessed.objects = itemProcessed.objects
                .filter(item => {
                    if (item.type === 'LEVEL' || item.type === 'CAM') {
                        return true
                    }
                    let check = false
                    for (let i = 0; i < mapObjTypes.length; i++) {
                        const webviewObjType = mapObjTypes[i]
                        if (item.type.startsWith(webviewObjType)) {
                        check = true
                        break
                        }
                    }
                    return check              
                })
                .map(item => {
                    for (let i = 0; i < mapObjTypes.length; i++) {
                        const webviewObjType = mapObjTypes[i]
                        if (item.type.startsWith(webviewObjType)) {
                            item.type = webviewObjType
                            item.status = item.type
                        }
                    }
                    return item
                })

                items.push(itemProcessed)
            })

            map.map = items
        })

        state.maps = maps
    },
    updateMap(state, { mapGroupId, mapId, map }) {
        let group = state.maps.find(group => group.id == mapGroupId) || null

        if (group) {
            let _map = group.map.find(map => map.id == mapId) || null

            if (_map) {
                Object.assign(_map, map)
            }
        }
    },
    setAlarms(state, alarms) {
        state.alarms = _.sortBy(alarms, item => -item.timestamp)
    },
    setMode(state, mode) {
        state.mode = mode
    },
    setGrid(state, grid) {
        state.grid = grid
    },
    setUplodedVideos(state, video){
        const canseledStatuses = ['ARCH_TASK_CANCELLED', 'ARCH_TASK_NOT_EXISTS'];
        if (canseledStatuses.indexOf(video.status) !== -1) {
            return;
        }
        let listVideo = [...state.uploadedVideos];
    
        let videoState = {
            percent: 0,
            allVideoCount: 0,
            completeVideoCount: 0,
            status: 'success'
        };

        let completeVideo = [];

        if( listVideo.length > 0 ) {
            const sameSessionVideo = listVideo.find(item => item.session === video.session);
            if (sameSessionVideo) {
                video.intervalDateVideo = sameSessionVideo.intervalDateVideo
            }
            listVideo = listVideo.filter(item => item.session !== video.session);
        }

        listVideo.push(video);

        listVideo = listVideo.map(item => {

            item.percent = parseInt(item.percent);
            if(item.hasOwnProperty('link')){
                if(!!item.link && !item.link.includes(location.origin)){
                    item.link = location.origin + item.link;
                }
                if(!!item.link){
                    item['statusLoad'] = 'success';
                    item['tooltipText'] = 'Video Complete';
                    completeVideo.push(item);
                    videoState.completeVideoCount += 1;
                    videoState.percent += 100;
                }
            } else {
                item['link'] = null;
                item['statusLoad'] = !!item.problem ? 'fail': 'progress';
                item['tooltipText'] = !!item.problem ? item.problem : 'Video Loading';
                videoState.percent += item.percent;
            }

            return item;
        });

        localStorage.setItem('uploadedVideos',JSON.stringify(completeVideo));
        state.uploadedVideos = listVideo;

        videoState.percent = videoState.percent / listVideo.length;
        videoState.allVideoCount = listVideo.length;
        videoState.status = videoState.completeVideoCount === videoState.allVideoCount ?
                                'success' : (listVideo.every(item => !!item.problem) ?
                                'fail' :'progress');

        state.videoState = videoState;

    },
    deleteUplodedVideo(state, id){
        const newUploadedVideos = [...state.uploadedVideos].filter(item => item.session !== id);
        const newCompleteVideos = newUploadedVideos.filter(item => !!item.link);
        const commonPercent = newUploadedVideos.reduce((summ, video) => !!video.link ? summ + 100 : summ + video.percent,0);

        localStorage.setItem('uploadedVideos',JSON.stringify(newCompleteVideos));

        state.uploadedVideos = newUploadedVideos;

        state.videoState = {
            allVideoCount: newUploadedVideos.length,
            percent: commonPercent / newUploadedVideos.length,
            completeVideoCount: newCompleteVideos.length,
            status: newCompleteVideos.length === newUploadedVideos.length ? 'success' :
                    (newUploadedVideos.every(item => !!item.problem) ? 'fail' :
                    'progress')
        };
    },
    setArchCnvEnabled(state, isEnabled) {
        state.archCnvEnabled = isEnabled
    },
    setWsWebConnect(state, wsWebConnect) {
        state.wsWebConnect = wsWebConnect
    },
    setObjectState(state, { getters, data }) {
        const activeMap = getters.getActiveMap
        if (activeMap) {
            const object = activeMap.objects.find(o => o.type === statusData.type && o.id === statusData.id)
            object.status = data.state
        }
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js